import { useEffect, useState } from 'react';
import { loadingPublicHolidaysMsg, t } from '../../../common/i18n/index.js';
import { useOpenFormAsync } from '../OpenFormProvider.js';

export const useOpenFormPublicHolidays = () => {
  const [data, setData] = useState<Date[]>([]);
  const async = useOpenFormAsync();

  useEffect(() => {
    const { controller } = async.fetch
      .getHolidays()
      .resolved(({ dates }) => setData(dates.map(timestamp => new Date(timestamp))))
      .rejected(text => async.actions.notification({ text, type: 'warning' }))
      .cache()
      .execute({ disable: true, message: t.JK3C(loadingPublicHolidaysMsg) });

    return () => controller.abort();
  }, [async]);

  return data;
};
